module.exports = __webpack_public_path__ + "static/img/p5.fda74af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p5.png
// module id = m8RY
// module chunks = 0